




























































































































import text from "../data/text.json";
import { MutationsTypes } from "@/store/modules/mutations-types";
import { ActionsTypes } from "@/store/modules/actions-types";
import Vue from "vue";
import Component from "vue-class-component";

@Component({})
export default class BasicInfo extends Vue {
  //Add type for text, object not passing
  text: any = text;

  get basicInfo() {
    return this.$store.state.basic;
  }

  get calcsInfo() {
    return this.$store.state.calcs;
  }

  get macroInfo() {
    return this.$store.state.macro;
  }

  updatePage(value: number) {
    this.$store.commit(MutationsTypes.UPDATE_PAGE, value);
  }

  calculateMacro(value: any, tdee: number) {
    this.$gtag.event("calculate-macro", {
      event_category: "calculated-macro-on-basic-page",
      event_label: "Calculated macro on basic page",
      value: 1
    });
    value.tdee = tdee;
    this.$store.dispatch(ActionsTypes.CACLULATE_MACRO, value);
  }

  setBasicInfo(value: any) {
    this.$store.dispatch(ActionsTypes.SET_BASICINFO, value);
  }

  calculateData(value: any) {
    if (value.gender) {
      value.gendDiff = this.text.formula[value.formula][value.gender];
    }
    this.$store.dispatch(ActionsTypes.CACLULATE_BMR, value);
  }
}
